import React, { Component } from "react";
import * as d3 from "d3";

class ComparerRow extends Component {
  row = React.createRef();

  componentDidMount() {
    const calcLeft = () => {
      const graphicWidth = d3.select("#comparer-graphic").node().clientWidth;
      const hoverWidth = d3.select("#comparer-hoverbox").node().clientWidth;
      if (d3.event.x < hoverWidth / 2) {
        return `${d3.event.x}px`;
      } else if (d3.event.x + hoverWidth / 2 > graphicWidth) {
        return `${d3.event.x - hoverWidth}px`;
      } else {
        return `${d3.event.x - hoverWidth / 2}px`;
      }
    };

    const setHTML = (d) => {
      const per_d = d3.format(".3")(
        (100 * parseInt(d.count_d)) /
          (parseInt(d.count_d) + parseInt(d.count_r))
      );
      const per_r = d3.format(".3")(
        (100 * parseInt(d.count_r)) /
          (parseInt(d.count_d) + parseInt(d.count_r))
      );
      this.props.activator(null, d.candidate_d, d.candidate_r, per_d, per_r);
    };

    d3.select(this.row.current)
      .selectAll("div")
      .data(this.props.data)
      .enter()
      .append("div")
      .attr("class", "comparer-cell")
      .style("background-color", (d) => {
        if (d.available) {
          const mov =
            (parseInt(d.count_d) - parseInt(d.count_r)) /
            (parseInt(d.count_d) + parseInt(d.count_r));
          const scaled = 0.5 + mov;
          return d3.interpolateRdBu(scaled);
        }
      })
      .on("touchstart", () => {
        d3.event.preventDefault();
      })
      .on("pointerover pointermove", () => {
        const d = document.elementFromPoint(d3.event.x, d3.event.y).__data__;
        if (d) {
          if (d.available) {
            const hoverHeight = d3.select("#comparer-hoverbox").node()
              .offsetHeight;
            setHTML(d);
            d3.select("#comparer-hoverbox")
              .style("opacity", 1)
              .style("top", `${d3.event.y - hoverHeight}px`)
              .style("left", calcLeft);
          }
        }
      })
      .on("pointerout", () => {
        d3.select("#comparer-hoverbox").style("opacity", 0);
      });
  }
  render() {
    return (
      <div className="comparer-row">
        <div className="comparer-row-label">{this.props.label}</div>
        <div className="comparer-cell-container" ref={this.row}></div>
      </div>
    );
  }
}

export default ComparerRow;
